import Header from './Components/Header/Header';
import LandingPage from './Components/LandingPage/LandingPage';
import Footer from './Components/Footer/Footer';
import AppManager from './Components/AppManager/AppManager';
import GlobalMessage from './Components/GlobalMessage/GlobalMessage';
import axios from 'axios';
import { Component } from 'react'
//Load the ne.dev ne.test urls from the config else use nebraska.gov
// console.log(process.env.REACT_APP_HOST_TYPE)
if (process.env.REACT_APP_HOST_TYPE !== 'production') {
  require('dotenv').config();
}

export default class App extends Component{
  constructor(props){
    super(props);
    this.state = {
        globalMessage:{
          message:[]
        },
        appManager: 
            {
                message: []
            }
    };
    this.getMessages = this.getMessages.bind(this);
}

componentDidMount(){
  this.getMessages();
}

  async getMessages(){
    let url = "/dmv/dls-status-check/lookup.cgi"
    if(process.env.REACT_APP_HOST_TYPE == "local"){
      // console.log("Running locally")
      url ="http://localhost:4000"
    }
    // console.log(url)
    let response = await axios.get(url)
    .then(function(response){
      return response
    })
    .catch(function(error){console.error(error)});
    const data = response.data;
    // console.log( data["global-messages"][0]);
    this.setState({ appManager: {...this.state.appManager, message: data["app-manager-message"]}});
    this.setState({ globalMessages: {...this.state.globalMessages, message: data["global-messages"][0]}});
  }

  render(){
    //Define the components that will be rendered
    let globalMessage, landingContents
    
    //Check if the state has values and render components based on values
    if(this.state.globalMessages){
      // console.table(this.state.globalMessage);
      globalMessage = <GlobalMessage message={this.state.globalMessages} />
    }
    //Check if AppManager is down else load LandingPage Component
    if(this.state.appManager.message){
      landingContents = <AppManager message={this.state.appManager.message} />
    }else{
      landingContents = <LandingPage/>
    }

    //Use conditional rendering to render the proper components
    return (
      <div className="h-screen w-full dark:bg-gray-900">
        <Header/>
        {globalMessage}
        {landingContents}
        <Footer/>
      </div>
    );
  }
}